import { useTranslation } from "react-i18next";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  Paper,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// RENAMED FUNCTION
function BetaPublicPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t("betaPublic.title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {t("betaPublic.description")}
        </Typography>

        <Box sx={{ my: 3 }}>
          <Typography variant="h6" gutterBottom>
            {t("betaPublic.firstStep")}
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleOutlineIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={t("betaPublic.signUpPrimary")}
                secondary={t("betaPublic.signUpSecondary")}
              />
            </ListItem>
          </List>
        </Box>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/signup")}
          sx={{ mt: 2 }}
        >
          {t("betaPublic.createProAccount")}
        </Button>
      </Paper>
    </Container>
  );
}

// RENAMED EXPORT
export default BetaPublicPage;
